import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions
import frCommon from '../locales/fr/common.json';
import frApp from '../locales/fr/app.json';
import enCommon from '../locales/en/common.json';
import enApp from '../locales/en/app.json';

const resources = {
  fr: {
    common: frCommon,
    app: frApp,
  },
  en: {
    common: enCommon,
    app: enApp,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
